<button type="button" [disabled]="!a" class="btn btn-success" style="margin-bottom: 14px;margin-left: 77%;"
  routerLink="/createSms">Send SMS</button>
<div class="row">
  <div class="checked_all">
    <input type="checkbox" [(ngModel)]="isMasterSel" name="list_name" value="h1" (change)="checkUncheckAll()"
      class="check_alll" />
    <label class="check_all">Select All / Unselect All</label>
  </div>
<div class="d-flex gap-2 mb-3 align-items-center">
 <span class="fw-semibold justify-content-center" >Display:</span>
   <select class="form-control w-25"
          [(ngModel)]="selectedMode"
          (change)="updateView()">
          <option [ngValue]="null" disabled>View Records</option>
    <option value="15"> 15 Records</option>
    <option value="50">50 Records</option>
    <option value="all">All Records</option>

  </select>
    <input type="text"
         class="form-control w-25"
         [(ngModel)]="search"
         (input)="onSearch()"
         placeholder="Search users by phone number..." />

  <!-- 🔍 Search Input -->

</div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div class="card card-border">
      <div>
        <div class="card-body" id="example_wrapper">
        </div>
        <table id="example" datatable class="display">
          <thead>

            <tr>
              <th>Sr. No.</th>
              <th>User</th>
              <th>Phone no.</th>
              <th>Send SMS</th>
              <!-- <th>View Reply</th>  -->
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="selectedMode === '15' || selectedMode === '50'">
              <tr *ngFor="let category of categories | paginate: { 
                      id: 'smsUsers', 
                      itemsPerPage: limit, 
                      currentPage: currentPage, 
                      totalItems: totalItems
                    }; let i = index">
                <td>{{ (currentPage - 1) * limit + i + 1 }}</td>
                <td>{{category.firstName}} {{category.lastName}}</td>
                <td>{{category?.phoneCode}} {{category?.mobileNumber}}</td>
                <td>
                  <div class="form-check">
                    <input type="checkbox" [(ngModel)]="category.isSelected" name="list_name"
                      value="{{category.mobileNumber}}" (change)="isAllSelected()" />
                  </div>
                </td>
                <!-- <td>
                        <a class="btn btn-success" [routerLink]="['/view-sent-mail']" [queryParams]="{userId:category._id}" matTooltip="View Reply" matTooltipPosition="right">
                          <span class="fa fa-eye"></span>
                        </a>
                      </td> -->
              </tr>
            </ng-container>
            <ng-container *ngIf="selectedMode === 'all'">
              <tr *ngFor="let category of categories; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ category.firstName }} {{ category.lastName }}</td>
                <td>{{category?.phoneCode}} {{ category?.mobileNumber }}</td>
                <td>
                  <div class="form-check">
                    <input type="checkbox" [(ngModel)]="category.isSelected" (change)="isAllSelected()" />
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <div *ngIf="categories.length == 0" class="no-data">No Data Found</div>
        <div class="pagination-container" *ngIf="(selectedMode === '15' || selectedMode === '50') && categories.length != 0">
          <pagination-controls id="smsUsers" (pageChange)="onPageChange($event)" [totalItems]="totalItems"
            [itemsPerPage]="limit">

          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>